import { HttpClient,MHTTPCL } from "./http/http-client";
import { ACCOUNTING_URL } from "../modules/accounting/services/invoices.service";
import { SETTINGS_URL,LABEL_URL } from "./common-urls";

export const ProAgencyService = {
  getProAgencyData: (api_account,label_ids,label_filter_id,start,end,limit) => MHTTPCL.post(LABEL_URL, {
    section: 'plugin',
    action: 'pro_agency_item_selection_interface_data',
    api_account:api_account,//'details',
    label_ids:label_ids,//'1,2',
    label_filter_id:label_filter_id,//,'2',
    start:start,//'2016-01-01',
    end:end,//'2021-02-01',
    limit:limit//'25'


  }),
  exportProAgencyData:(api_account,label_ids,label_filter_id,start,end,limit)=> MHTTPCL.post(LABEL_URL, {
    section: 'plugin',
    action: 'pro_agency_export_data_from_interface',
    api_account:api_account,//'details',
    label_ids:label_ids,//'1,2',
    product_ids:'',
    label_filter_id:'2',
    start:'2016-01-01',
    end:'2021-02-01',
    limit:'25'


  }),

  transferProAgencyData:(product_ids,api_account)=>MHTTPCL.post(LABEL_URL,{
    section: 'plugin',
    action: 'pro_agency_transfer_products',
    product_ids:product_ids,//'details',
    api_account:api_account,//'1,2',
  }),

  resultProAgencyData:(product_ids)=>MHTTPCL.post(LABEL_URL,{
    section: 'plugin',
    action: 'pro_agency_item_result_interface_data',
    product_ids:product_ids,//'details',
  }),


  omitProduct:(product_id)=>MHTTPCL.post(LABEL_URL,{
    section: 'plugin',
    action: 'pro_agency_omit_product',
    product_id:product_id,
  })
  
}



